<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div style="display: flex; justify-content: center; flex-direction: column">
      <div class="light-shade box rounded-corners" style="width: 100%; max-width: 800px; margin-top: 10px">
        <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
          <div>Sample Tickets</div>
        </div>
        <div style="width: 100%; padding: 20px; display: flex; margin: auto">
          <table style="width: 100%">
            <tr>
              <td class="nassau-ticket-cell">
                <div id="divBabylon" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/Babylon_T.gif" />
                  <div>
                    New York State Park Police<br />
                    Babylon, NY
                  </div>
                </div>
              </td>
              <td class="nassau-ticket-cell">
                <div id="divCommunityCollege" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/Community-college_T.gif" />
                  <div>
                    Nassau Community College<br />
                    Nassau, NY<br />
                  </div>
                </div>
              </td>
              <td class="nassau-ticket-cell">
                <div id="divNY" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/NY_T.gif" />
                  <div>
                    Department of Public Safety<br />
                    Town of Hempstead, NY<br />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="nassau-ticket-cell">
                <div id="divMahasset" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/Manhasset_T.gif" />
                  <div>
                    Manhasset Park District<br />
                    Town of North Hempstead<br />
                    Nassau, NY<br />
                  </div>
                </div>
              </td>
              <td class="nassau-ticket-cell">
                <div id="divNHampstead" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/N-Hampstead_T.gif" />
                  <div>
                    Town of North Hempstead<br />
                    Manhasset, NY<br />
                  </div>
                </div>
              </td>
              <td class="nassau-ticket-cell">
                <div id="divNassauHealthcare" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/Nassau-Healthcare_T.gif" />
                  <div>
                    Nassau Health Care Corporation<br />
                    Nassau, NY<br />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="nassau-ticket-cell">
                <div id="divCourt" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/Court_T.gif" />
                  <div>
                    Police Department<br />
                    Nassau, NY<br />
                  </div>
                </div>
              </td>
              <td class="nassau-ticket-cell">
                <div id="divNassauCounty" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/Nassau-county_T.gif" />
                  <div>
                    Police Department<br />
                    Nassau, NY<br />
                  </div>
                </div>
              </td>
              <td class="nassau-ticket-cell">
                <div id="divPortWashington" class="nassau-ticket">
                  <img src="{{ env.assetsPath }}/branding/nassau/tickets/Port-washington_T.gif" />
                  <div>
                    Police Department<br />
                    Port Washington, NY<br />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>
